var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 882.2",
    style: {
      enableBackground: "new 0 0 882.2 882.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#00D1FF;}\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.63 -97.669)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -257.63 97.669)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13840.1133,
    y1: 1136.6707,
    x2: 13840.1133,
    y2: 2311.7517,
    gradientTransform: "matrix(0.1984 0 0 0.1984 -1079.163 -223.6654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#090220"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#170659"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1667.2,
    cy: 1667.2,
    r: 1665.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1118.7,1253.2c-13.3-16.5-33.5-25.7-55.1-25.7H618.8c-3.7,0-6.9-1.4-9.6-3.7c-2.3-2.3-3.7-5-3.7-8.3V915.8 c0-3.2,1.4-6,3.7-8.3c2.8-2.8,6-4.1,9.6-3.7h470c118.4,0,220.8,48.7,307.1,145.5l114.3,139.5l-222.6,271.3L1118.7,1253.2z  M1940.3,1048c85.8-95.9,188.7-144.1,308.5-144.1h468.7c3.2-0.5,6.4,0.9,8.7,2.8c2.3,2.3,3.2,5.5,2.8,9.2v299.7 c0,3.2-0.9,6-2.8,8.3c-2.3,2.8-5.5,4.1-8.7,3.7h-444.8c-21.1-0.5-41.3,9.2-55.1,25.7l-327.7,398.9l329.1,401.6 c13.3,15.1,33,24.3,53.2,23.9H2717c3.2-0.5,6.9,1.4,8.7,3.7c1.8,2.8,3.2,6.4,2.8,9.6v299.7c0,3.2-0.9,6-2.8,8.3 c-2.3,2.8-5.5,4.1-8.7,3.7h-468.2c-119.8,0-221.7-48.7-307.1-145.5L1669,1924.2L1396.4,2257c-85.8,96.9-188.7,145.5-308.5,145.5 H618.8c-3.2,0.5-6.9-1.4-8.7-3.7c-2.3-2.8-3.2-6.4-2.8-9.6v-299.7c0-3.2,0.9-6,2.8-8.3c2.3-2.8,5.5-4.1,8.7-3.7h444.8 c21.1,0,41.3-9.6,55.1-25.7l321.8-392.9L1940.3,1048z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnxIcon);
export default __webpack_public_path__ + "static/media/snx_icon.7d30715038d9a5dddbc1321832b07ac8.svg";
export { ForwardRef as ReactComponent };